import { IDashboardTileComponentProps } from "@components/dashboard";
import DashboardTileBackground from "@components/dashboard/DashboardTileBackground";
import ProgressBar from "@components/progressBar";
import { DashboardTileHeaderWithBottomPadding, ProgressBarTitle, ProgressBarWrapper } from "@pages/home/Home.style";
import { getCompanyCurrency } from "@utils/CompanyUtils";
import customFetch from "@utils/customFetch";
import React, { useContext, useEffect } from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { REST_API_URL } from "../../constants";
import { AppContext } from "../../contexts/appContext/AppContext.types";
import { formatCurrency } from "../../types/Currency";

interface IProps extends IDashboardTileComponentProps, WithTranslation {

}

const EMPLOYEE_BENEFIT_LIMITS_URL = `${REST_API_URL}/DashboardData/EmployeeBenefitLimits`;

interface IBenefitLimitsData {
    HealthBenefitsLimit: number;
    HealthBenefitsValue: number;
    LeisureBenefitsLimit: number;
    LeisureBenefitsValue: number;
    RetirementSavingsLimit: number;
    RetirementSavingsValue: number;
}

const BenefitLimitsProgress: React.FC<IProps> = (props) => {
    const context = useContext(AppContext);

    const [data, setData] = React.useState<IBenefitLimitsData>(null);

    useEffect(() => {
        customFetch(EMPLOYEE_BENEFIT_LIMITS_URL).then((res) => {
            if (res.ok) {
                res.json().then((data) => {
                    setData(data);
                }).catch((err) => {
                    console.error("Error parsing JSON:", err);
                });
            }
        });
    }, []);

    const progressBarFormatter = (value: number, parts: number) => {
        return (
            <>
                <span>{props.t("Home:EmployeeBenefitLimits.Utilization")}:</span>&nbsp;
                <b>
                    <span>{`${formatCurrency(value, getCompanyCurrency(context), 0)} / ${formatCurrency(parts, getCompanyCurrency(context), 0)}`}</span>
                </b>
            </>
        );
    };

    return (
        <DashboardTileBackground backgroundColor={props.info.backgroundColor}
                                 inEditMode={props.inEditMode}>
            <DashboardTileHeaderWithBottomPadding>{props.info.title}</DashboardTileHeaderWithBottomPadding>
            {!!data?.HealthBenefitsLimit && <ProgressBarWrapper key={"HealthBenefits"}>
                <ProgressBarTitle>{props.t("Home:EmployeeBenefitLimits.HealthBenefits")}</ProgressBarTitle>
                <ProgressBar value={data.HealthBenefitsValue} parts={data.HealthBenefitsLimit}
                             descriptionFormatter={progressBarFormatter}
                             color={"C_CHART_purple"}/>
            </ProgressBarWrapper>}
            {!!data?.LeisureBenefitsLimit && <ProgressBarWrapper key={"LeisureBenefits"}>
                <ProgressBarTitle>{props.t("Home:EmployeeBenefitLimits.LeisureBenefits")}</ProgressBarTitle>
                <ProgressBar value={data.LeisureBenefitsValue} parts={data.LeisureBenefitsLimit}
                             descriptionFormatter={progressBarFormatter}
                             color={"C_CHART_blue"}/>
            </ProgressBarWrapper>}
            {!!data?.RetirementSavingsLimit && <ProgressBarWrapper>
                <ProgressBarTitle>{props.t("Home:EmployeeBenefitLimits.RetirementSavings")}</ProgressBarTitle>
                <ProgressBar value={data.RetirementSavingsValue} parts={data.RetirementSavingsLimit}
                             descriptionFormatter={progressBarFormatter}
                             color={"C_CHART_green"}/>
            </ProgressBarWrapper>}
        </DashboardTileBackground>
    );
};

export default withTranslation(["Home"])(React.memo(BenefitLimitsProgress));